import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: `${theme.spacing(5)}px ${theme.spacing(5)}px`,
    backgroundColor: '#FCF9F8',
    height: '100%'
  },
  generalInfo: {
    borderRadius: '6px',
    backgroundColor: '#F8F4F2',
    marginBottom: theme.spacing(4)
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  nonDefault: {
    '& > div': {
      border: '1px solid #F7901E'
    }
  },
  menuItem: {
    fontFamily: 'National',
    fontSize: 16
  },
  rightBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginLeft: '30px',
    backgroundColor: '#FFFFFF',
    marginTop: theme.spacing(4)
  },
  leftBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: '30px',
    backgroundColor: '#FFFFFF',
    marginTop: theme.spacing(4)
  },
  emptyProgress: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(8, 10),
    paddingTop: theme.spacing(3),
    height: '80vh',
    width: '100%'
  },
  icon: {
    marginBottom: '4px'
  },
  header: {
    color: '#8688A1',
    marginBottom: '4px'
  },
  text: {
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '21px',
    color: '#8688A1',
    fontWeight: 'normal',
    textAlign: 'center'
  },
  topHeader: {
    color: '#00000',
    marginBottom: '12px',
    fontWeight: 500
  }
}))
